import Vue from "vue";
import VueRouter from 'vue-router';
import LayerListPage from '../pages/LayerListPage/Index';
import LayerDetailPage from "../pages/LayerDetailPage/LayerDetailPage";

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [
        {
            path: '/',
            component: LayerListPage,
        },
        {
            name: 'layer-detail',
            path: '/layers/:layerCode?',
            component: LayerDetailPage,
            props: true

        },
    ]
});

export default router;